module.exports = __webpack_public_path__ + "img/1458295704.99ea04bb.jpg";